<div class="px-4 py-8 ">
  <h3 class="mb-5 text-center text-xl font-semibold">Add {{this.data.label}}</h3>
  <form [formGroup]="form">
    <div class="relative">
      <span class="text-[10px] absolute right-0 top-[-15px] text-max-length">
        <span *ngIf="data.maxLength" [ngClass]="{
        'text-red': this.form.get('value')?.value?.length  > data.maxLength
      }"> {{ form?.value?.value?.length }} </span>/{{ data.maxLength }} </span>
      <!-- Room Name -->
      <mat-form-field appearance="outline" class="w-full mb-4">
        <mat-label>Text</mat-label>
        <textarea rows="5" matInput formControlName="value" placeholder="Text"></textarea>
        <mat-error *ngIf="form.get('value')?.hasError('maxlength')">
          Maximum {{ data.maxLength }} characters allowed
        </mat-error>
        <mat-error *ngIf="form.get('value')?.hasError('required')">
          Field is required
        </mat-error>
        <mat-error *ngIf="form.get('value').hasError('whitespace')">
          Value cannot be empty or only spaces.
        </mat-error>
        <mat-error *ngIf="form.get('value')?.hasError('duplicate')">
          Duplicate entry already exists
        </mat-error>
      </mat-form-field>

    </div>

  </form>
  <!-- Buttons -->
  <div class="flex justify-between pt-4 space-x-2">
    <button type="button" mat-stroked-button (click)="onClose()">Cancel</button>
    <button [disabled]="this.form.invalid" type="button" mat-flat-button color="primary" (click)="save()">
      {{ isLoading ? "Saving..." : "Save" }}
    </button>
  </div>
</div>
